import GenericBuilderPage from '@/components/builder/GenericBuilderPage';
import { pakketBuilderAPI } from '@/lib/api';

export default function PakketBuilderPage() {
  return (
    <GenericBuilderPage
      api={pakketBuilderAPI}
      branding={{
        kindLabel: 'Pakket Builder',
        title: 'Stel jouw pakket samen',
        subtitle: 'Kies een pakket-type en personaliseer het op jouw organisatie.',
        headlinePrefix: 'Stel jouw ',
        headlineHighlight: 'eigen pakket',
        headlineSuffix: ' samen',
        ctaLabel: 'Start samenstellen',
        successTitle: 'Bedankt!',
        successMessage: 'We hebben je pakket-aanvraag goed ontvangen. We nemen binnen 1-2 werkdagen contact met je op met een passend voorstel.',
        accent: 'pink',
        testIdPrefix: 'pakket-builder',
      }}
    />
  );
}
